import View from '@shared/components/layout-default/layout-default-router-view';
import { service_packages } from './service-packages';
import { media } from './media';
import { numbers } from './numbers';
import { phone_lists } from './phone-lists';
import { time_conditions } from './time-conditions';
import { operators } from './operators';
import { worksheet } from './worksheets';
import { stats } from './stats';

export const pbx = [
  {
    path: 'pbx',
    component: View,
    meta: {
      permissions: ['module_pbx_is_allowed']
    },
    children: [
      {
        path: '',
        name: 'pbx.module',
        redirect: {
          name: 'pbx.service-package.index'
        }
      },

      service_packages,
      media,
      numbers,
      phone_lists,
      time_conditions,
      operators,
      worksheet,
      stats,
      {
        path: 'settings',
        name: 'pbx.setting.index',
        component: () =>
          import(/* webpackChunkName: 'pbx-settings' */ '@pbx/pages/pbx-settings-page'),
        meta: {
          title: {
            code: 'pbx.breadcrumb.setting.index'
          }
        }
      }
    ]
  }
];
